import { sharedEnvironment } from '@vinnova/environments';

export const environment = {
  production: sharedEnvironment.utv.production,
  name: sharedEnvironment.utv.name,
  returnUrl: sharedEnvironment.utv.enkatRegisterUrl,
  etjansterCommonUrl: sharedEnvironment.utv.etjansterCommonUrl,
  ansokanUrl: sharedEnvironment.utv.ansokanUrl,
  bpUrl: sharedEnvironment.utv.bpUrl,
  cookieDomain: sharedEnvironment.utv.cookieDomain,
  projektApiUrl: `${sharedEnvironment.utv.gatewayUrl}/projekt`,
  projektSignalRUrl: `${sharedEnvironment.utv.gatewayUrl}/projekt`,
  etjansterCommonApiUrl: `${sharedEnvironment.utv.gatewayUrl}/etjanster`,
  resourceStringUrl: `${sharedEnvironment.utv.gatewayUrl}/resourcestring/projekt`,
  sprakHanteringApiUrl: `${sharedEnvironment.utv.gatewayUrl}/resourcestring`,
  oregApiUrl: `${sharedEnvironment.utv.gatewayUrl}/organisationsregistret`,
  logServiceApiUrl: `${sharedEnvironment.utv.gatewayUrl}/logger`,
  projektUrl: sharedEnvironment.utv.projektUrl,
  featureUrl: `${sharedEnvironment.utv.gatewayUrl}/projekt/feature`,
  externalLinks: sharedEnvironment.utv.externalLinks,
  baseGatewayUrl: sharedEnvironment.utv.gatewayUrl,
  apimSubscriptionKey: sharedEnvironment.utv.apimSubscriptionKey,
  chatbotApiUrl: `${sharedEnvironment.utv.gatewayUrl}/projekt/chatbot`,
  b2cMsalConfig: {
    ...sharedEnvironment.b2cMsalConfig(
      `${sharedEnvironment.utv.gatewayUrl}/projekt`,
      sharedEnvironment.utv.azureAdB2C.clientId.projektClientId,
      sharedEnvironment.utv.azureAdB2C.clientId.projektApiClientId,
    ),
    authority: sharedEnvironment.utv.azureAdB2C.authority,
    scope: `https://${sharedEnvironment.utv.azureAdB2C.tenant}.onmicrosoft.com/${sharedEnvironment.utv.azureAdB2C.clientId.projektApiClientId}/all`,
    tenant: sharedEnvironment.utv.azureAdB2C.tenant,
    policies: sharedEnvironment.utv.azureAdB2C.policies,
    clientId: sharedEnvironment.utv.azureAdB2C.clientId,
    allowRedirectInIframe: true,
  },
  ga4MeasurementId: sharedEnvironment.utv.ga4MeasurementId,
};
